let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3wEVm")).then(() => parcelRequire('9FWL3'));